import { getGreeting } from '@shared/greeting';

// Keep encoding and segment limits aligned with backend sms-rules.ts.
const gsm = new Set(
  Array.from(
    '@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà',
  ),
);
const extended = new Set(Array.from('\f^{}\\[~]|€'));

export function estimateSms(text: string) {
  const unicode = Array.from(text).some(char => !gsm.has(char) && !extended.has(char));
  const units = unicode
    ? text.length
    : Array.from(text).reduce((sum, char) => sum + (extended.has(char) ? 2 : 1), 0);
  const singleLimit = unicode ? 70 : 160;
  const multipartLimit = unicode ? 67 : 153;
  const parts = units === 0 ? 0 : units <= singleLimit ? 1 : Math.ceil(units / multipartLimit);
  return { unicode, units, parts };
}

export const SMS_EXAMPLE_VALUES: Record<string, string> = {
  clientName: getGreeting('Laurin').replace(/,\s*$/, ''),
  serviceName: 'Střih muzsky',
  appointmentDate: '30. 9.',
  appointmentTime: '16:30',
  depositAmount: '500 Kč',
  bankAccount: '123456789/0100',
  reviewUrl: 'https://example.cz/recenze',
  reason: 'nemoc',
};

export function smsExample(content: string, overrides: Record<string, string> = {}) {
  const values = { ...SMS_EXAMPLE_VALUES, ...overrides };
  return content.replace(/\{([^}]+)\}/g, (match, key: string) => values[key] ?? match);
}
